// extracted by mini-css-extract-plugin
export default {"root":"AttachFile_root__g3WH4","label":"AttachFile_label__Zay7t","card":"AttachFile_card__Unx-b","input":"AttachFile_input__fLmPI"};